var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#000e28;stroke-miterlimit:10;stroke-width:1.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LCS-Iconographie"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16,15.74a2,2,0,1,1,2-2A2,2,0,0,1,16,15.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16,11.76a2,2,0,1,0,2,2A2,2,0,0,0,16,11.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.15,7.51A8.58,8.58,0,0,0,16,5h-.35A8.5,8.5,0,0,0,9.59,7.77,8.77,8.77,0,0,0,7.25,14c0,3.64,2.95,8,8.75,13,5.8-5,8.75-9.35,8.75-13v-.35A8.64,8.64,0,0,0,22.15,7.51Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoMap);
export default __webpack_public_path__ + "static/media/icono-map.2c923e42.svg";
export { ForwardRef as ReactComponent };